import messages from '../../../../messages/tabs';

const tabSchema = (props) => {
  const intl = props.intl;
  return {
    title: intl.formatMessage(messages.Tabs),

    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.Default),
        fields: ['title'],
      },
    ],

    properties: {
      title: {
        title: intl.formatMessage(messages.TabTitle),
      },
      // assetType: {
      //   title: intl.formatMessage(messages.AssetType),
      //   choices: [
      //     ['image', intl.formatMessage(messages.Image)],
      //     ['icon', intl.formatMessage(messages.Icon)],
      //   ],
      // },
      // assetPosition: {
      //   title: intl.formatMessage(messages.AssetPosition),
      //   choices: [
      //     ['top', intl.formatMessage(messages.Top)],
      //     ['left', intl.formatMessage(messages.LeftSide)],
      //     ['right', intl.formatMessage(messages.RightSide)],
      //   ],
      //   default: 'top',
      // },
      // image: {
      //   title: intl.formatMessage(messages.Image),
      //   widget: 'object_browser',
      //   mode: 'image',
      //   allowExternals: true,
      //   selectedItemAttrs: ['image_field', 'image_scales'],
      // },
      // imageSize: {
      //   title: intl.formatMessage(messages.AssetSize),
      //   choices: [
      //     ['icon', intl.formatMessage(messages.Small)],
      //     ['tile', intl.formatMessage(messages.Medium)],
      //     ['thumb', intl.formatMessage(messages.Large)],
      //   ],
      //   default: 'icon',
      // },
      // iconSize: {
      //   title: intl.formatMessage(messages.AssetSize),
      //   choices: [
      //     ['small', intl.formatMessage(messages.Small)],
      //     ['medium', intl.formatMessage(messages.Medium)],
      //     ['large', intl.formatMessage(messages.Large)],
      //   ],
      //   default: 'small',
      // },
      // icon: {
      //   title: intl.formatMessage(messages.IconName),
      // },
      // hideTitle: {
      //   title: intl.formatMessage(messages.HideTitle),
      //   type: 'boolean',
      // },
    },

    required: [],
  };
};

// const toggleIconField = (schema, child) => {
//   const cloned = cloneDeepSchema(schema);

//   cloned.fieldsets[0].fields = [
//     ...cloned.fieldsets[0].fields,
//     ...(child.assetType === 'icon'
//       ? ['icon', 'iconSize', 'assetPosition', 'hideTitle']
//       : []),
//     ...(child.assetType === 'image'
//       ? ['image', 'imageSize', 'assetPosition', 'hideTitle']
//       : []),
//   ];

//   return cloned;
// };

export const blockSchema = (props) => {
  const intl = props.intl;
  return {
    title: intl.formatMessage(messages.TabsBlock),
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.Default),
        fields: ['data'],
      },
    ],
    properties: {
      data: {
        title: intl.formatMessage(messages.Tabs),
        type: 'tabs',
        schema: tabSchema(props),
        // schemaExtender: toggleIconField,
      },
      // default: 'flex-start',
    },
    required: [],
  };
};
